/**
 * @file useScanSoundAction.ts
 * @description Пункт «Звук скана: вкл/выкл» в меню «⋯» складского документа
 * (phase19.24 этап 1, шаг 1).
 *
 * Тумблер звука уехал из поля скана: он занимал 56px рядом с полем на каждом
 * экране и на 360px отжимал ввод. Настройка одна на устройство и задаётся в
 * «Настройки склада → Рабочее место», а в документе остаётся быстрый доступ —
 * кладовщик выключает бип, не уходя со сборки.
 *
 * Хук, а не константа: подпись пункта зависит от текущего состояния, и меню
 * обязано перерисоваться сразу после переключения.
 */

import { Volume2, VolumeX } from "lucide-react";

import type { RowAction } from "../ui/RowActionsMenu";
import { useScanFeedbackSetting } from "../ui/useScanFeedbackSetting";

export function useScanSoundAction(): RowAction {
  const { enabled, toggle } = useScanFeedbackSetting();
  return {
    key: "scan-sound",
    label: enabled ? "Звук скана: вкл" : "Звук скана: выкл",
    icon: enabled ? Volume2 : VolumeX,
    run: toggle,
  };
}
